{
  "common": {
    "title": "شاركاتي",
    "welcome": "مرحباً بكم في شاركاتي",
    "login": "تسجيل الدخول",
    "signup": "إنشاء حساب",
    "logout": "تسجيل الخروج",
    "dashboard": "لوحة القيادة",
    "settings": "الإعدادات",
    "home": "الرئيسية",
    "loading": "جاري التحميل...",
    "error": "حدث خطأ ما",
    "enabled": "مفعّل",
    "disabled": "معطّل",
    "workspace": "مساحة العمل",
    "sovereign_os": "نظام التشغيل السيادي"
  },
  "nav": {
    "home": "الرئيسية",
    "platform": "المنصة",
    "services": "الخدمات",
    "about": "من نحن",
    "contact": "اتصل بنا",
    "start_project": "ابدأ المشروع",
    "theme_light": "الوضع الفاتح",
    "theme_dark": "الوضع الداكن",
    "language_selector": "محدد اللغة",
    "lang_fr": "الفرنسية",
    "lang_en": "الإنجليزية",
    "lang_ar": "العربية",
    "logo_alt": "شعار شاركاتي",
    "hero_backdrop_alt": "خلفية مؤسساتية للتكنولوجيا المالية",
    "close_menu_alt": "إغلاق القائمة",
    "pricing": "الأسعار"
  },
  "auth": {
    "login": {
      "title": "الوصول إلى النظام",
      "subtitle": "اتصل ببنيتك التحتية السيادية.",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "forgot_password": "نسيت كلمة المرور؟",
      "submit": "تسجيل الدخول",
      "no_account": "ليس لديك حساب؟",
      "signup_link": "إنشاء حساب",
      "error_invalid": "بيانات الاعتماد غير صالحة. يرجى المحاولة مرة أخرى.",
      "error_system": "خطأ في النظام. يرجى الاتصال بالدعم."
    },
    "signup": {
      "title": "حساب جديد",
      "subtitle": "ابدأ رحلتك نحو السيادة المالية.",
      "initialization": "تهيئة الملف الشخصي",
      "step_title": "الخطوة {step} من 2",
      "name": "الاسم الكامل",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "next": "متابعة",
      "back": "رجوع",
      "submit": "أنشئ حسابي",
      "back_to_selection": "العودة إلى اختيار الملف الشخصي",
      "have_account": "لديك حساب بالفعل؟",
      "login_link": "تسجيل الدخول",
      "error_select_profile": "يرجى اختيار ملف شخصي للمتابعة.",
      "error_password_length": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
      "error_institution_email": "يجب على المؤسسات استخدام بريد إلكتروني رسمي (.dz أو .gov).",
      "error_exists": "هناك حساب مسجل بهذا البريد الإلكتروني بالفعل."
    },
    "profiles": {
      "INDIVIDUAL": "فرد",
      "individual_desc": "مستثمرون أفراد وأصحاب مشاريع.",
      "AUTO_ENTREPRENEUR": "مقاول ذاتي",
      "auto_entrepreneur_desc": "مستقلون وأصحاب أعمال حرة.",
      "ENTERPRISE": "مؤسسة",
      "enterprise_desc": "شركات ناشئة، مؤسسات صغيرة ومتوسطة وشركات كبرى.",
      "INCUBATOR": "حاضنة",
      "incubator_desc": "مسرعات أعمال وهياكل مرافقة.",
      "INVESTOR": "مستثمر",
      "investor_desc": "صناديق استثمار ومستثمرون ملائكة.",
      "INSTITUTION": "مؤسسة رسمية",
      "institution_desc": "هيئات حكومية ووزارات."
    },
    "fields": {
      "full_name": "الاسم الكامل",
      "full_name_placeholder": "الاسم واللقب",
      "phone": "رقم الهاتف",
      "phone_placeholder": "+213 -- -- -- --",
      "company_name": "اسم المؤسسة",
      "company_name_placeholder": "اسم شركتك أو هيكلك",
      "type": "نوع المؤسسة",
      "country": "بلد الإقامة",
      "country_default": "الجزائر",
      "incubator_name": "اسم الحاضنة",
      "incubator_name_placeholder": "اسم مسرعة الأعمال",
      "structure": "نوع الهيكل",
      "investor_name": "اسم المستثمر / الصندوق",
      "investor_name_placeholder": "الاسم الكامل",
      "profile_type": "نوع الملف الشخصي",
      "experience": "مستوى الخبرة",
      "institution_name": "اسم المؤسسة",
      "institution_name_placeholder": "الوزارة / الهيئة",
      "department": "القسم / المديرية",
      "department_placeholder": "مثال: مديرية الابتكار",
      "role": "الدور / الوظيفة",
      "role_placeholder": "مدير",
      "email_institutional": "البريد الإلكتروني المؤسساتي",
      "email_professional": "البريد الإلكتروني المهني",
      "placeholder_email": "name@domain.com",
      "placeholder_password": "••••••••",
      "placeholder_name": "الاسم هنا",
      "password": "كلمة المرور"
    },
    "options": {
      "startup": "شركة ناشئة",
      "pme": "مؤسسة صغيرة ومتوسطة",
      "project": "مشروع",
      "public": "عام",
      "private": "خاص",
      "individual": "فردي",
      "fund": "صندوق / مجموعة",
      "beginner": "مبتدئ",
      "advanced": "متقدم"
    },
    "demo": {
      "label": "وصول تجريبي احترافي",
      "description": "استكشف المنصة بملف تعريف مؤسسة مهيأ مسبقًا.",
      "email_label": "البريد الإلكتروني",
      "password_label": "كلمة المرور",
      "email": "demo@charikaty.com",
      "button": "الدخول للتجربة",
      "account_name": "حساب تجريبي",
      "tooltip": "حساب تجريبي للجنة"
    },
    "forgot_password": {
      "title": "استعادة الوصول",
      "subtitle": "أدخل بريدك الإلكتروني لتلقي رابط إعادة التعيين.",
      "email_label": "البريد الإلكتروني",
      "email_placeholder": "name@domain.com",
      "submit": "إرسال رابط إعادة التعيين",
      "back_to_login": "العودة لتسجيل الدخول",
      "success_title": "تم إرسال البريد",
      "success_message": "إذا كان هناك حساب بهذا البريد، ستتلقى رابطاً قريباً.",
      "error_not_found": "لم يتم العثور على حساب بهذا البريد.",
      "error_system": "حدث خطأ أثناء إرسال البريد."
    },
    "reset_password": {
      "title": "كلمة مرور جديدة",
      "subtitle": "يرجى تعيين كلمة مرور جديدة آمنة.",
      "new_password": "كلمة المرور الجديدة",
      "confirm_password": "تأكيد كلمة المرور",
      "submit": "إعادة تعيين كلمة المرور",
      "success_title": "نجاح",
      "success_message": "تم تحديث كلمة المرور بنجاح.",
      "error_invalid_token": "رابط إعادة التعيين غير صالح أو منتهي الصلاحية.",
      "error_mismatch": "كلمات المرور غير متطابقة.",
      "error_system": "حدث خطأ أثناء إعادة التعيين."
    },
    "layout": {
      "visual_title": "البنية التحتية الموثوقة للاقتصاد الجزائري.",
      "visual_desc": "محطة واحدة لإدارة أصولك المالية والقانونية والاستراتيجية بدقة سيادية.",
      "feature_audit": "التدقيق المؤسسي والامتثال",
      "feature_treasury": "إدارة الخزينة المتقدمة",
      "feature_investor": "مجموعات مستثمرين معتمدين",
      "back_to_site": "العودة إلى الموقع الرئيسي",
      "protocol_label": "بروتوكول شاركاتي • نشر عالمي موحد"
    },
    "admin_demo": {
      "label": "وصول تجريبي للمشرف",
      "description": "مخصص للمستثمرين، لجان الشركات الناشئة، ومقيمي الحاضنات.",
      "button": "الدخول كمسؤول تجريبي",
      "account_name": "مشرف تجريبي",
      "tooltip": "حساب تجريبي للإدارة",
      "email": "admin@charikaty.dz"
    }
  },
  "kyc": {
    "title": "التحقق من الهوية",
    "nif_label": "الرقم التعريفي الجبائي (NIF)",
    "nif_placeholder": "أدخل الرقم التعريفي الجبائي",
    "nin_label": "رقم التعريف الوطني (NIN)",
    "nin_placeholder": "أدخل رقم التعريف الوطني",
    "file_label_auto": "بطاقة المقاول الذاتي (نسخة ضوئية/صورة)",
    "file_label_id": "بطاقة التعريف الوطنية (الوجهين)",
    "file_placeholder": "قم بسحب وإسقاط ملفك هنا أو انقر للتصفح",
    "file_error_size": "الملف كبير جداً (الأقصى 5 ميجابايت)",
    "file_error_format": "صيغة غير مدعومة (JPG, PNG, PDF فقط)",
    "submit": "التحقق من الهوية",
    "skip": "تخطي في الوقت الحالي"
  },
  "kyc_profile": {
    "title": "أكمل ملفك الشخصي",
    "subtitle": "مطلوب معلومات إضافية لنوع ملفك الشخصي."
  },
  "landing": {
    "hero": {
      "badge": "بنية تحتية سيادية",
      "title_main": "القيادة الاستراتيجية لـ",
      "title_accent": "المؤسسات الحديثة.",
      "description": "المنصة المتكاملة للمالية، القانون والضرائب. قم بإدارة هيكلك السيادي بالكامل بدقة مؤسساتية.",
      "cta_start": "ابدأ الآن",
      "cta_explore": "استكشف المنصة"
    },
    "intro": {
      "label": "تحليل السياق",
      "title": "عمليات موحدة.",
      "subtitle": "تقضي شاركاتي على الحواجز بين عملياتك المصرفية والقانونية والإدارية. محطة واحدة لدفع نموك بشكل آمن.",
      "feature_1": {
        "title": "المرونة التشغيلية",
        "desc": "أتمتة العمليات اليدوية لزيادة الرشاقة."
      },
      "feature_2": {
        "title": "الدقة الضريبية",
        "desc": "الاستباق والأتمتة للتصريحات الدورية."
      },
      "feature_3": {
        "title": "الشبكة المؤسساتية",
        "desc": "اتصال مباشر مع المستثمرين والشركاء المعتمدين."
      }
    },
    "pillars": {
      "label": "نظام النمو المتكامل",
      "title": "ثلاثة ركائز أساسية.",
      "subtitle": "بنية معيارية مصممة للمرونة والأمن والأداء المؤسساتي.",
      "legal": {
        "title": "القانون الرقمي",
        "desc": "دورة حياة قانونية كاملة، من التأسيس المعتمد إلى إدارة النظام الأساسي."
      },
      "finance": {
        "title": "المالية والضرائب",
        "desc": "رؤية استشرافية وامتثال ضريبي مؤتمت في الوقت الفعلي."
      },
      "invest": {
        "title": "محرك الاستثمار",
        "desc": "مجمعات استثمارية معتمدة ومنصة لجمع الأموال السيادية."
      },
      "explore": "استكشف"
    },
    "targets": {
      "label": "الفئات المستهدفة",
      "title": "حل لكل فاعل.",
      "subtitle": "يتكيف بروتوكول شاركاتي ديناميكيًا مع ملفك المؤسساتي.",
      "individual": {
        "title": "فرد",
        "desc": "مستثمرون أفراد وأصحاب مشاريع رقمية."
      },
      "business": {
        "title": "مؤسسة",
        "desc": "شركات ناشئة، مؤسسات صغيرة ومتوسطة وشركات كبرى."
      },
      "incubator": {
        "title": "حاضنة",
        "desc": "هياكل مرافقة عامة وخاصة."
      },
      "investor": {
        "title": "مستثمر",
        "desc": "صناديق، مستثمرون ملائكة ومستثمرون وسيطون."
      },
      "institution": {
        "title": "مؤسسة رسمية",
        "desc": "هيئات حكومية ووزارات."
      }
    },
    "final_cta": {
      "title": "سيطر على نظامك المتكامل بسيادة تامة اليوم.",
      "subtitle": "انضم إلى البنية التحتية المرجعية للفاعلين الاقتصاديين المحدثين.",
      "button": "أنشئ حسابي"
    },
    "footer": {
      "tagline": "النظام السيادي لإدارة الأعمال الذكية.",
      "product": "المنتج",
      "legal": "قانوني",
      "contact": "اتصل بنا",
      "privacy": "الخصوصية",
      "security": "الأمن",
      "terms": "الشروط",
      "support": "الدعم",
      "audit": "التدقيق",
      "hq": "المقر الرئيسي",
      "copyright": "© 2026 // نظام تشغيل شاركاتي السيادي. مصمم للنمو.",
      "privacy_policy": "سياسة الخصوصية",
      "audit_security": "التدقيق والأمن"
    },
    "city_data": {
      "network_hub": "Network Hub v2.4 // الجزائر",
      "alger": "الجزائر",
      "oran": "وهران",
      "mostaganem": "مستغانم",
      "tlemcen": "تلمسان",
      "sidi_bel_abbes": "سيدي بلعباس",
      "stats": {
        "population": "مجمع السكان",
        "startups": "تناغم الشركات الناشئة",
        "funding": "الوصول لرأس المال",
        "strategic_index": "المؤشر الاستراتيجي",
        "rank": "المرتبة {n}"
      }
    }
  },
  "legal_page": {
    "header": {
      "title": "مركز الامتثال",
      "subtitle": "طبقة الثقة والشفافية",
      "version": "إصدار {version}",
      "last_update": "آخر تحديث: {date}",
      "full_dossier": "الملف القانوني"
    },
    "sidebar": {
      "nav_label": "التنقل",
      "identity": "الهوية القانونية",
      "terms": "الشروط العامة",
      "privacy": "الخصوصية",
      "data": "استخدام البيانات",
      "rights": "حقوق المستخدمين",
      "downloads": "وثائق PDF",
      "contact": "الاتصال القانوني",
      "status_valid": "امتثال معتمد",
      "status_desc": "نظام معتمد وفقاً لمعايير حماية البيانات المالية (الجزائر 2024-2026)."
    },
    "identity": {
      "badge": "القسم 01",
      "title": "هوية المنصة",
      "subtitle": "معلومات التسجيل والكيان القانوني المشغل للنظام.",
      "company_name_label": "الاسم التجاري",
      "company_name": "شركة Charikaty Sovereign OS Technologies Inc.",
      "subsidiary": "تابعة لمجموعة GSD (السيادة الرقمية العالمية)",
      "jurisdiction_label": "الاختصاص القضائي",
      "jurisdiction": "الجزائر العاصمة، الجزائر"
    },
    "terms": {
      "badge": "القسم 02",
      "title": "الشروط العامة",
      "pdf_button": "الشروط العامة (PDF)",
      "items": [
        {
          "title": "الاستخدام المصرح به",
          "content": "استخدام شريكتي مخصص حصرياً لإدارة الأعمال والاستشارات المالية المؤسسية."
        },
        {
          "title": "الملكية الفكرية",
          "content": "جميع مكونات الذكاء الاصطناعي (LegalDZ، Genvest) محمية بموجب قوانين حقوق النشر الدولية والمحلية."
        },
        {
          "title": "السيادة الرقمية",
          "content": "يوافق المستخدم على أن بياناته لا تغادر أبداً المحيط السيادي للبنية التحتية في الجزائر."
        },
        {
          "title": "الإنهاء",
          "content": "في حالة الإخلال الجسيم بالقوانين المالية السارية، قد يتم تعليق الوصول دون إشعار مسبق."
        }
      ]
    },
    "privacy": {
      "badge": "القسم 03 و 04",
      "title": "سياسة الخصوصية",
      "subtitle": "نحن نطبق معايير عسكرية لحماية بياناتكم. إليكم كيف نعالج معلوماتكم.",
      "consent_title": "إدارة الموافقة",
      "consent_labels": {
        "analytics": "التحليلات وحركة المرور",
        "marketing": "التسويق والعروض",
        "security": "أمن النظام"
      },
      "rights_title": "حقوقكم (القانون 18-07)",
      "rights_list": [
        "الحق في الوصول الكامل إلى بياناتكم",
        "الحق في التصحيح الفوري",
        "الحق في النسيان (بعد تدقيق قانوني)",
        "قابلية نقل البيانات إلى أطراف ثالثة معتمدة"
      ],
      "inventory_title": "جرد البيانات",
      "table": {
        "headers": {
          "type": "نوع البيانات",
          "purpose": "الغرض",
          "duration": "المدة"
        },
        "rows": [
          {
            "type": "الهوية الضريبية",
            "purpose": "التحقق من الكيان القانوني",
            "duration": "مدة الاشتراك + 10 سنوات"
          },
          {
            "type": "التدفقات المالية",
            "purpose": "التحسين التنبؤي (Genvest)",
            "duration": "7 سنوات (التزام ضريبي)"
          },
          {
            "type": "سجلات الاتصال",
            "purpose": "الأمن وتدقيق الاحتيال",
            "duration": "24 شهراً"
          }
        ]
      }
    },
    "downloads": {
      "badge": "القسم 06",
      "title": "التنزيلات القانونية",
      "subtitle": "الوثائق الرسمية، شهادات الامتثال وإثباتات السيادة.",
      "full_dossier": "الملف القانوني الكامل",
      "privacy_pdf": "الخصوصية (PDF)",
      "terms_pdf": "الشروط العامة"
    },
    "contact": {
      "badge": "القسم 07",
      "title": "الاتصال بالقسم القانوني",
      "subtitle": "سؤال حول الامتثال؟ بلاغ عن خلل أمني؟ استخدم هذه القناة ذات الأولوية.",
      "labels": {
        "full_name": "الاسم الكامل",
        "email": "البريد الإلكتروني المؤسسي",
        "subject": "موضوع الطلب",
        "message": "رسالة مفصلة"
      },
      "placeholders": {
        "full_name": "السيد إبراهيم ك. / مكتب محاماة س",
        "email": "contact@entreprise.dz",
        "subject": "مثال: طلب تدقيق بيانات GDPR/الجزائر",
        "message": "صف طلبك بدقة..."
      },
      "secure_label": "إرسال آمن (TLS 1.3)",
      "submit": "إرسال الطلب",
      "validation": {
        "name_short": "الاسم قصير جداً (3 أحرف على الأقل)",
        "email_invalid": "يرجى إدخال بريد إلكتروني صالح",
        "subject_short": "الموضوع قصير جداً (5 أحرف على الأقل)",
        "message_short": "الرسالة قصيرة جداً (20 حرفاً على الأقل)"
      }
    },
    "toasts": {
      "pdf_success": "تم إنشاء المستند بنجاح",
      "pdf_desc": "جاري تنزيل {type}.pdf...",
      "contact_success": "تم إرسال الطلب إلى القسم القانوني",
      "contact_desc": "سنرد عليكم خلال 48 ساعة عمل.",
      "consent_success": "تم تحديث التفضيلات",
      "consent_desc": "{key} الآن {status}."
    },
    "footer": {
      "copyright": "© 2026 تقنيات شريكتي. تعمل تحت الولاية القضائية الجزائرية.",
      "status": "حالة النظام",
      "certificates": "بوابة الشهادات",
      "api_compliance": "امتثال واجهة البرمجيات",
      "tagline": "بنية تحتية لنظام تشغيل سيادي — طبقة الثقة"
    }
  },
  "contact_page": {
    "header": {
      "title": "اتصل بنا",
      "subtitle": "سؤال تقني، قانوني أو مالي؟ خبراؤنا تحت تصرفكم لمرافقة مخصصة."
    },
    "info": {
      "title": "معلومات الاتصال",
      "hq": {
        "title": "المقر الرئيسي",
        "address": "حي الأعمال، برج شاركاتي، الجزائر العاصمة، الجزائر"
      },
      "phone": {
        "title": "الهاتف",
        "hours": "الاثنين-الخميس: 8:30 صباحاً - 5:00 مساءً"
      },
      "email": {
        "title": "البريد الإلكتروني المؤسساتي",
        "support": "دعم 24/7 للحسابات المميزة"
      }
    },
    "form": {
      "title": "إرسال رسالة",
      "labels": {
        "name": "الاسم الكامل",
        "email": "البريد الإلكتروني المهني",
        "message": "رسالتك"
      },
      "placeholders": {
        "name": "مثال: أمينة بن علي",
        "email": "مثال: a.benali@entreprise.dz",
        "message": "كيف يمكننا مساعدتك؟"
      },
      "submit": "إرسال الرسالة",
      "submitting": "جاري الإرسال..."
    },
    "toasts": {
      "error_title": "خطأ في التحقق",
      "error_desc": "يرجى ملء جميع الحقول المطلوبة.",
      "success_title": "تم إرسال الرسالة",
      "success_desc": "سيرد عليك فريقنا المؤسساتي في أقرب وقت ممكن."
    },
    "categories": {
      "legal": {
        "title": "قانوني",
        "desc": "مساعدة في الإنشاء والقانون الأساسي"
      },
      "finance": {
        "title": "المالية",
        "desc": "أسئلة حول الخزينة والضرائب"
      },
      "invest": {
        "title": "الاستثمار",
        "desc": "دعم وحدة جينفست ورأس المال المخاطر"
      }
    },
    "faq": {
      "title": "قاعدة المعرفة",
      "search_placeholder": "ابحث عن إجابة...",
      "no_results": "لا توجد نتائج لـ \"{query}\"",
      "items": [
        {
          "category": "legal",
          "question": "كيف يتم اعتماد القانون الأساسي المُنشأ؟",
          "answer": "يستخدم القانون الأساسي المُنشأ بواسطة شاركاتي نظام LegalDz AI المدرَّب على قانون التجارة الجزائري الساري. وهو مُهيَّأ مسبقاً ليُقبل من طرف الموثقين والسجل التجاري، وإن كان التوثيق الرسمي يبقى إلزامياً بموجب القانون."
        },
        {
          "category": "finance",
          "question": "هل يمكنني ربط حسابي البنكي المهني؟",
          "answer": "نعم، تتيح المنصة التكامل عبر API بنكي آمن لمزامنة تدفقاتك المالية في الوقت الفعلي، مما يضمن رؤية دقيقة لصحتك المالية."
        },
        {
          "category": "account",
          "question": "كيف أضيف متعاونين إلى مساحتي؟",
          "answer": "اذهب إلى «الإعدادات» > «الفريق»، ثم انقر على «دعوة عضو». ستتمكن من تحديد أدوار صارمة (مثل: قراءة فقط، محاسب، مدير) عبر نظام RBAC لدينا."
        },
        {
          "category": "legal",
          "question": "هل المحاكي الضريبي دقيق؟",
          "answer": "يأخذ المحاكي بعين الاعتبار نظام IBS/IRG وTAP واشتراكات CASNOS/CNAS وفق تشريع قانون المالية الساري. يتم تحديث المعدلات بشكل ديناميكي."
        }
      ]
    },
    "ticket": {
      "title": "فتح تذكرة دعم",
      "subtitle": "لم تجد الإجابة؟ تواصل مع فريق الدعم التقني لدينا.",
      "labels": {
        "category": "فئة المشكلة",
        "subject": "موضوع الطلب",
        "description": "وصف مفصّل"
      },
      "categories": {
        "bug": "مشكلة تقنية (خلل)",
        "legal": "مساعدة قانونية / توليد",
        "billing": "الفواتير والاشتراكات",
        "other": "طلب آخر"
      },
      "placeholders": {
        "subject": "مثال: خطأ أثناء التحقق من الاسم",
        "description": "صف مشكلتك بالتفصيل..."
      },
      "submit": "إرسال التذكرة",
      "submitting": "جاري إنشاء التذكرة..."
    }
  },
  "support_page": {
    "header": {
      "title": "مركز الدعم",
      "subtitle": "وثائق تقنية، أسئلة شائعة ومساعدة مخصصة."
    },
    "categories": {
      "legal": {
        "title": "قانوني",
        "desc": "مساعدة في التأسيس والقوانين الأساسية"
      },
      "finance": {
        "title": "المالية",
        "desc": "أسئلة حول الخزينة والضرائب"
      },
      "invest": {
        "title": "الاستثمار",
        "desc": "دعم وحدة جينفيست ورأس المال الاستثماري"
      }
    },
    "faq": {
      "title": "قاعدة المعرفة",
      "search_placeholder": "البحث عن إجابة...",
      "no_results": "لا توجد نتائج لـ \"{query}\"",
      "items": [
        {
          "category": "قانوني",
          "question": "كيف يتم اعتماد القوانين الأساسية المنشأة؟",
          "answer": "تستخدم القوانين الأساسية المنشأة بواسطة شاركاتي LegalDz AI، المدرب على القانون التجاري الجزائري ساري المفعول. وهي مهيأة مسبقاً ليتم قبولها من قبل الموثقين والمركز الوطني للسجل التجاري (CNRC)، على الرغم من أن التوقيع الموثق النهائي يظل إلزامياً بموجب القانون."
        },
        {
          "category": "المالية",
          "question": "هل يمكنني ربط حسابي البنكي للمؤسسة؟",
          "answer": "نعم، تسمح المنصة بالتكامل عبر واجهة برمجة تطبيقات بنكية آمنة لمزامنة تدفقاتك النقدية في الوقت الفعلي، مما يضمن رؤية دقيقة لصحتك المالية."
        },
        {
          "category": "حساب",
          "question": "كيف يمكنني إضافة متعاونين إلى مساحتي؟",
          "answer": "انتقل إلى \"الإعدادات\" > \"الفريق\"، ثم انقر فوق \"دعوة عضو\". ستتمكن من تحديد أدوار صارمة (مثل: للقراءة فقط، محاسب، مدير) عبر نظام RBAC الخاص بنا."
        },
        {
          "category": "قانوني",
          "question": "هل محاكي الضرائب دقيق؟",
          "answer": "يأخذ المحاكي في الاعتبار نظام IBS/IRG، وTAP، ومساهمات CASNOS/CNAS وفقاً لتشريعات قانون المالية الحالي. يتم تحديث المعدلات ديناميكياً."
        }
      ]
    },
    "ticket": {
      "title": "فتح تذكرة",
      "subtitle": "لا تجد الإجابة؟ اتصل بالدعم الفني لدينا.",
      "labels": {
        "category": "فئة المشكلة",
        "subject": "موضوع الطلب",
        "description": "وصف مفصل"
      },
      "categories": {
        "bug": "مشكلة تقنية (خطأ)",
        "legal": "مساعدة قانونية / إنشاء",
        "billing": "الفواتير والاشتراكات",
        "other": "طلب آخر"
      },
      "placeholders": {
        "subject": "مثال: خطأ أثناء التحقق من الاسم",
        "description": "اشرح مشكلتك بالتفصيل..."
      },
      "submit": "إرسال التذكرة",
      "submitting": "جاري إنشاء التذكرة..."
    },
    "toasts": {
      "error_title": "خطأ",
      "error_desc": "يرجى إدخال موضوع لتذكرتك.",
      "success_title": "تم إنشاء التذكرة",
      "success_desc": "تم تسجيل طلب الدعم الخاص بك #T-9842. سيتصل بك أحد الوكلاء."
    }
  },
  "audit_page": {
    "title": "سجل التدقيق",
    "subtitle": "شفافية تامة لعمليات البنية التحتية وسلامة نظام شراكتي.",
    "section_title": "سجلات النزاهة",
    "section_subtitle": "نظرة عامة على أحداث النظام الرئيسية.",
    "filters": {
      "all": "الكل",
      "security": "الأمن",
      "system": "النظام",
      "auth": "الوصول"
    },
    "types": {
      "security": "الأمن",
      "system": "النظام",
      "auth": "المصادقة"
    },
    "logs": {
      "messages": {
        "ssl_update": "تحديث شهادات SSL/TLS",
        "db_backup": "نسخ احتياطي مشفر لقاعدة البيانات",
        "auth_failed": "محاولة تسجيل دخول فاشلة (تم حظر عنوان IP)",
        "security_patch": "نشر تصحيح الأمان الإصدار 2.4.1",
        "gdpr_audit": "تدقيق آلي للامتثال للقانون العام لحماية البيانات (GDPR)",
        "latency_detected": "تم رصد تباطؤ على العقدة AP-Est"
      },
      "time": {
        "ago_2_min": "منذ دقيقتين",
        "ago_15_min": "منذ 15 دقيقة",
        "ago_1h": "منذ ساعة",
        "yesterday": "أمس",
        "ago_2_days": "منذ يومين"
      }
    },
    "load_more": "تحميل السجل الكامل"
  },
  "privacy_page": {
    "title": "سياسة الخصوصية",
    "subtitle": "بياناتكم ملككم. نحن الحراس ولَسنا المالكين.",
    "usage": {
      "title": "استخدام البيانات",
      "desc": "نحن نجمع فقط البيانات الضرورية لتشغيل خدماتنا المالية والقانونية. لن يتم بيع أي بيانات لأطراف ثالثة.",
      "items": {
        "profile": "ملف الشركة",
        "transactions": "سجل المعاملات",
        "documents": "الوثائق القانونية المستخرجة"
      }
    },
    "rights": {
      "title": "حقوقكم المكفولة",
      "desc": "وفقًا للمعايير الدولية (RGPD) والمحلية، تمتلكون سيطرة كاملة على معلوماتكم الشخصية والمؤسسية.",
      "items": {
        "access": "حق الوصول والتصحيح",
        "erasure": "حق الحذف (الحق في النسيان)",
        "portability": "حق نقل البيانات"
      }
    },
    "manager": {
      "button": "إدارة بياناتي وتفضيلاتي",
      "title": "مركز التفضيلات",
      "subtitle": "إدارة دقيقة لجمع بياناتكم.",
      "essential": {
        "title": "ملفات تعريف الارتباط الأساسية",
        "desc": "ضرورية للوظائف الأساسية للمنصة (المصادقة، الأمان)."
      },
      "analytics": {
        "title": "التحليلات والأداء",
        "desc": "تساعدنا على فهم الاستخدام لتحسين خدماتنا."
      },
      "marketing": {
        "title": "التسويق والعروض",
        "desc": "يسمح بتلقي توصيات للخدمات الشريكة المناسبة."
      },
      "third_party": {
        "title": "التكاملات مع أطراف ثالثة",
        "desc": "يسمح بمشاركة البيانات مع التطبيقات الخارجية المتصلة ببيئتكم."
      },
      "cancel": "إلغاء",
      "save": "حفظ الخيارات",
      "toasts": {
        "save_success": "تم حفظ تفضيلات الخصوصية",
        "save_desc": "تم تحديث خياراتكم بنجاح على خوادمنا."
      }
    }
  },
  "hq_page": {
    "header": {
      "title": "المقر الرئيسي HQ",
      "subtitle": "المركز الحيوي لتكنولوجيا Charikaty Sovereign OS."
    },
    "algiers": "الجزائر العاصمة، الجزائر",
    "sections": {
      "address": {
        "title": "العنوان الفعلي",
        "content": "حي الأعمال باب الزوار\nبرج شراكتي، الطوابق 12-15\n16024 الجزائر العاصمة"
      },
      "phone": {
        "title": "اللوحة الهاتفية",
        "content": "الرئيسي: +213 (0) 21 00 00 00\nالعلاقات العامة: +213 (0) 21 00 00 01"
      },
      "email": {
        "title": "البريد الإلكتروني",
        "content": "الصحافة: presse@charikaty.dz\nالشراكات: partners@charikaty.dz"
      }
    },
    "cta": "الحصول على الاتجاهات (Maps)",
    "building_name": "برج شراكتي",
    "coordinates": "36.7139° N, 3.1906° E"
  },
  "security_page": {
    "header": {
      "title": "الأمن والبنية التحتية",
      "subtitle": "بنية الصفر ثقة (Zero-Trust) المصممة لحماية الأصول الحيوية."
    },
    "features": [
      {
        "title": "تشفير الطرفين (E2E)",
        "desc": "تشفير AES-256 بت لجميع البيانات المخزنة والمنقولة."
      },
      {
        "title": "المرونة المتعددة المناطق (Multi-AZ)",
        "desc": "تكرار نشط في مناطق جغرافية متعددة لضمان استمرارية الخدمة."
      },
      {
        "title": "مراقبة على مدار الساعة 24/7",
        "desc": "اكتشاف الحالات الشاذة المدعوم بالذكاء الاصطناعي في الوقت الفعلي."
      }
    ],
    "status": {
      "title": "حالة النظام",
      "subtitle": "التحقق من سلامة البنية التحتية في الوقت الفعلي.",
      "operational": "جاهز بنسبة 100٪"
    },
    "services": [
      {
        "label": "بوابة واجهة البرمجيات الرئيسية",
        "status": "مثالي"
      },
      {
        "label": "عنقود قواعد البيانات",
        "status": "مؤمّن"
      },
      {
        "label": "نظام المصادقة",
        "status": "مثالي"
      }
    ],
    "check": {
      "button": "التحقق من الأمن العام",
      "analyzing": "جاري التحليل...",
      "success": "لم يتم اكتشاف أي ثغرات"
    }
  },
  "terms_page": {
    "header": {
      "title": "شروط الاستخدام",
      "subtitle": "القواعد والمسؤوليات المتعلقة باستخدام المنصة."
    },
    "sections": [
      {
        "title": "1. قبول الشروط",
        "content": "من خلال الوصول إلى بنية شاركاتي التحتية، فإنك توافق على الالتزام بهذه الشروط العامة. توفر منصتنا أدوات للإدارة المالية والقانونية والضريبية الموجهة للمحترفين."
      },
      {
        "title": "2. مسؤوليات المستخدم",
        "content": "يتعهد المستخدم بتقديم معلومات دقيقة عند إنشاء مساحته السيادية. سيؤدي استخدام وثائق مزورة لأغراض إنشاء القوانين الأساسية أو المحاكاة الضريبية إلى تعليق الحساب فوراً."
      },
      {
        "title": "3. الملكية الفكرية",
        "content": "تظل جميع الخوارزميات والواجهات والنماذج التي تم إنشاؤها بواسطة شاركاتي (بما في ذلك عبر وحدة LegalDz AI) ملكية حصرية لشركة Charikaty Sovereign OS Technologies Inc."
      }
    ],
    "consent": {
      "title": "الموافقة",
      "subtitle": "يرجى تأكيد قراءة شروطنا والموافقة عليها للاستمرار في استخدام خدماتنا بأمثل وجه.",
      "accepted_status": "الشروط مقبولة حالياً",
      "refuse": "رفض",
      "accept": "قبول"
    },
    "toasts": {
      "success_title": "تمت الموافقة على الشروط",
      "success_desc": "شكراً لمصادقتكم على الشروط العامة للاستخدام.",
      "error_title": "تم رفض الشروط",
      "error_desc": "قد يتم تقييد بعض ميزات المنصة."
    }
  },
  "dashboard": {
    "account_menu": {
      "profile": "الملف الشخصي",
      "aria_label": "قائمة الحساب"
    },
    "topbar": {
      "dashboard": "لوحة القيادة",
      "legal": "قانوني",
      "finance": "المالية",
      "genvest": "جينفست",
      "operational": "الحالة التشغيلية",
      "search_placeholder": "بحث...",
      "light_mode": "الوضع الفاتح",
      "dark_mode": "الوضع الداكن"
    },
    "nav": {
      "overview": "نظرة عامة",
      "infrastructure": "البنية التحتية",
      "dashboard": "لوحة القيادة",
      "legal": "قانوني",
      "companies": "الشركات",
      "finance": "المالية",
      "genvest": "جينفست",
      "menu": "القائمة",
      "home": "الرئيسية",
      "my_documents": "مستنداتي",
      "my_companies": "شركاتي",
      "my_treasury": "خزانتي",
      "my_assets": "أصولي",
      "settings": "الإعدادات",
      "legal_overview": "التنقل",
      "trademark_validation": "التحقق من العلامة التجارية",
      "ai_assistant": "مساعد الذكاء الاصطناعي",
      "legal_simulation": "المحاكاة القانونية",
      "create_company": "إنشاء شركة",
      "legal_events": "الأحداث القانونية",
      "documents": "الوثائق",
      "our_partners": "شركاؤنا",
      "integrations": "التكاملات",
      "compliance": "الامتثال",
      "finance_home": "الرئيسية المالية",
      "strategic_alerts": "تنبيهات استراتيجية",
      "financial_management": "الإدارة المالية",
      "advisor_insight": "المساعد المالي",
      "treasury": "الخزانة",
      "project_evaluation": "تقييم المشروع",
      "project_financial_study": "الدراسة المالية للمشروع",
      "e_taxes": "الضرائب الإلكترونية",
      "financial_reports": "التقارير المالية",
      "performance_indicators": "مؤشرات الأداء",
      "portfolio_simulation": "محاكاة المحفظة",
      "creation": "إنشاء",
      "portfolio": "المحفظة",
      "risks": "المخاطر",
      "risk_simulation": "محاكاة المخاطر",
      "ai_predictive": "تحليل وتنبؤ الذكاء الاصطناعي",
      "market": "السوق",
      "institutional_funding": "التمويل المؤسسي",
      "infra_cockpit": "قمرة القيادة للبنية التحتية",
      "databases": "قواعد البيانات",
      "security": "الأمن",
      "crm_users": "إدارة العملاء والمستخدمين",
      "connectivity": "الاتصال",
      "recovery": "الاسترداد",
      "logout": "تسجيل الخروج",
      "cockpit": "قمرة القيادة"
    },
    "desc": {
      "dashboard": "قمرة القيادة العالمية",
      "my_documents": "مركز الموارد",
      "my_companies": "الكيانات القانونية",
      "my_treasury": "الصحة المالية",
      "my_assets": "إدارة الأصول",
      "settings": "الحساب والتفضيلات",
      "legal_overview": "الإدارة القانونية العالمية",
      "trademark_validation": "التحقق من الاسم والعلامة والنطاق",
      "ai_assistant": "الذكاء القانوني",
      "legal_simulation": "اختبارات الجدوى",
      "create_company": "إطلاق هيكل",
      "legal_events": "المحاضر والاجتماعات والقوانين الأساسية",
      "documents": "الخزنة والنماذج",
      "our_partners": "شبكة الخبراء",
      "integrations": "بوابات واجهة برمجة التطبيقات",
      "compliance": "المراقبة والالتزامات",
      "finance_home": "المؤشرات الرئيسية",
      "strategic_alerts": "نقاط الاهتمام",
      "financial_management": "حسابات الموردين والعملاء",
      "advisor_insight": "دعم القرار المالي",
      "treasury": "تدفقات نقدية في الوقت الفعلي",
      "project_evaluation": "العائد على الاستثمار والمخاطر",
      "project_financial_study": "الاستثمارات الداخلية",
      "e_taxes": "التصريحات الضريبية",
      "financial_reports": "الأرشيف والصادرات",
      "performance_indicators": "تحليل متعمق",
      "institutional_partners": "خبراء مؤسسيون",
      "portfolio_simulation": "بناء استراتيجية",
      "creation_portfolio": "إنشاء محفظتك",
      "portfolio_follow": "المراقبة والإدارة",
      "exposure_analysis": "تحليل التعرض",
      "risk_scenarios": "سيناريوهات المخاطر",
      "strategic_analytics": "تحليلات استراتيجية",
      "live_stream": "بث مباشر",
      "sovereign_pipeline": "خط الأنابيب السيادي",
      "strategic_partners": "شركاء استراتيجيون",
      "infra_core": "قلب المنصة",
      "distributed_systems": "الأنظمة الموزعة",
      "cybersecurity": "الأمن السيبراني",
      "customer_engine": "محرك العملاء",
      "load_balancing": "توازن الحمل",
      "backup_plan": "خطة النسخ الاحتياطي والاسترداد"
    },
    "sections": {
      "main_management": "الإدارة الرئيسية",
      "intelligence_compliance": "الذكاء والامتثال",
      "partners_ecosystem": "الشركاء والنظام البيئي",
      "financial_operations": "العمليات المالية",
      "strategic_intelligence": "الذكاء الاستراتيجي",
      "analysis_projects": "التحليل والمشاريع",
      "ecosystem": "النظام البيئي",
      "operations_assets": "العمليات والأصول",
      "analysis_simulation": "التحليل والمحاكاة",
      "market_ecosystem": "السوق والنظام البيئي",
      "navigation": "التنقل"
    },
    "overview": {
      "title": "لوحة القيادة",
      "subtitle": "نظرة عامة على نظام Charikaty الخاص بك",
      "access_module": "الدخول إلى الوحدة",
      "legal_desc": "إدارة الكيانات والامتثال والمحاكيات القانونية.",
      "finance_desc": "الإدارة المالية والتقارير ومؤشرات الأداء.",
      "genvest_desc": "الاستثمارات وتحليل المحفظة والفرص.",
      "infra_desc": "مراقبة النظام والأمن والاتصال.",
      "settings_desc": "إعدادات الحساب والتفضيلات والأمن."
    },
    "legal_page": {
      "title": "الشركات والقانون",
      "description": "بوابة آمنة لوحدات الحوكمة والإدارة القانونية للشركات.",
      "badge": "الحوكمة",
      "modules": {
        "nav": {
          "title": "التنقل",
          "desc": "نظرة عامة وتوجيه الوحدة القانونية"
        },
        "brand": {
          "title": "التحقق من العلامة التجارية",
          "desc": "التحقق من التوفر وحماية العلامة"
        },
        "ai": {
          "title": "مساعد الذكاء الاصطناعي",
          "desc": "مستشار قانوني ذكي يعتمد على الذكاء الاصطناعي"
        },
        "sim": {
          "title": "المحاكاة القانونية",
          "desc": "محاكي الهياكل والآثار القانونية"
        },
        "create": {
          "title": "إنشاء شركة",
          "desc": "إطلاق وتأسيس كيانات جديدة"
        },
        "events": {
          "title": "الأحداث القانونية",
          "desc": "إدارة الاجتماعات والتغييرات والعقود"
        },
        "docs": {
          "title": "الوثائق",
          "desc": "الخزنة وتوليد الوثائق الرسمية"
        },
        "partners": {
          "title": "شركاؤنا",
          "desc": "شبكة استراتيجية من الخبراء والشركاء"
        },
        "integrations": {
          "title": "التكاملات",
          "desc": "الاتصال بالأنظمة الخارجية وواجهات البرمجة"
        },
        "compliance": {
          "title": "الامتثال",
          "desc": "المراقبة التنظيمية وتدقيق الامتثال"
        }
      }
    },
    "finance_page": {
      "title": "وحدة التحكم المالية",
      "description": "توجيه الأداء والامتثال الضريبي ودعم اتخاذ القرار الاستراتيجي لشركتك.",
      "badge": "مباشر",
      "modules": {
        "acc": {
          "title": "المركز المحاسبي",
          "desc": "إدارة المحاسبة والتدفقات المالية"
        },
        "advisor": {
          "title": "مستشار شراكتي",
          "desc": "الذكاء الاصطناعي لدعم اتخاذ القرار"
        },
        "cash": {
          "title": "إدارة النقدية",
          "desc": "تتبع السيولة وتوقعات التدفق النقدي"
        },
        "eval": {
          "title": "تقييم المشاريع",
          "desc": "تحليل الربحية ومحاكاة الاستثمارات"
        },
        "projects": {
          "title": "مشاريع الاستثمار",
          "desc": "التتبع التشغيلي للمشاريع الجارية"
        },
        "taxes": {
          "title": "الضرائب الإلكترونية",
          "desc": "الإقرارات الضريبية والامتثال G50"
        },
        "reports": {
          "title": "التقارير المالية",
          "desc": "الميزانيات العمومية وبيانات الدخل"
        },
        "indicators": {
          "title": "المؤشرات والبيانات",
          "desc": "تصور مؤشرات الأداء الرئيسية"
        },
        "alerts": {
          "title": "التنبيهات الاستراتيجية",
          "desc": "إدارة التنبيهات والإشعارات المالية"
        },
        "partners": {
          "title": "الشركاء الماليون",
          "desc": "النظام البيئي المصرفي والمؤسسي"
        }
      }
    },
    "genvest_page": {
      "title": "وحدة تحكم GenVest",
      "description": "وحدة التوجيه الاستراتيجي للأصول والمحاكاة التنبؤية للسوق.",
      "badge": "النظام نشط",
      "modules": {
        "portfolio": {
          "title": "المحفظة النشطة",
          "desc": "إدارة المراكز وتتبع الأداء في الوقت الفعلي"
        },
        "ai": {
          "title": "الذكاء الاصطناعي التنبؤي",
          "desc": "إشارات الاستثمار والتحليل الكمي"
        },
        "opportunities": {
          "title": "فرص السوق",
          "desc": "الذكاء الاستراتيجي واكتشاف النمو"
        },
        "risks": {
          "title": "تحليل المخاطر",
          "desc": "مراقبة التعرض والامتثال التنظيمي"
        },
        "sim_port": {
          "title": "محاكاة المحفظة",
          "desc": "محاكاة تخصيص الأصول وتوقعات العائد"
        },
        "sim_risk": {
          "title": "محاكاة المخاطر",
          "desc": "اختبارات الإجهاد ومحاكاة السيناريوهات"
        },
        "deal": {
          "title": "تدفق الصفقات المؤسسية",
          "desc": "الوصول إلى التمويل المؤسسي"
        },
        "creation": {
          "title": "إنشاء المحفظة",
          "desc": "سير عمل إنشاء الصناديق الجديدة"
        },
        "integrations": {
          "title": "التكاملات وواجهة برمجة التطبيقات",
          "desc": "الربط بأنظمة خارجية"
        },
        "alerts": {
          "title": "التنبيهات الاستراتيجية",
          "desc": "نظام المراقبة وإشعارات المخاطر"
        }
      }
    },
    "settings_page": {
      "title": "الإعدادات والأمان",
      "description": "إدارة معلومات شركتك، الوصول، وتفضيلات الأمان لحسابك.",
      "legal": {
        "title": "الإطار القانوني والحوكمة",
        "subtitle": "القانون التجاري الجزائري",
        "regime_label": "النظام التنظيمي",
        "rc_option": "القانون التجاري (RC)",
        "zes_option": "المنطقة الاقتصادية الخاصة (ZES)",
        "sig_label": "التوقيع الرقمي",
        "sig_status": "شهادة ANC نشطة",
        "save_btn": "حفظ الإعدادات"
      },
      "services": {
        "title": "الخدمات والأتمتة",
        "subtitle": "وحدات الإدارة النشطة",
        "mod1": {
          "name": "مراقبة Tracfin",
          "desc": "يقظة المعاملات التلقائية"
        },
        "mod2": {
          "name": "حساب ضريبة G50",
          "desc": "تخصيص الضرائب التلقائي"
        },
        "mod3": {
          "name": "مزامنة RC",
          "desc": "ربط مباشر بالسجل التجاري"
        },
        "mod4": {
          "name": "تدقيق الذكاء الاصطناعي",
          "desc": "كشف الحالات الشاذة الذكي"
        },
        "active": "نشط",
        "inactive": "معطل"
      },
      "system": {
        "title": "حالة النظام",
        "node1": "الخادم الرئيسي",
        "node2": "بوابة DGI",
        "node3": "محرك الحساب",
        "status_optimal": "مثالي",
        "status_connected": "متصل",
        "status_stable": "مستقر",
        "api_btn": "توليد مفاتيح API"
      },
      "security": {
        "title": "الأمان",
        "desc": "يستخدم حسابك تشفيرًا على مستوى البنوك. تجنب مشاركة وصولك.",
        "status": "التشفير نشط"
      },
      "support": {
        "label": "بحاجة للمساعدة؟",
        "desc": "الفنيون لدينا متاحون لمساعدتك في التكوين.",
        "btn": "اتصل بالدعم"
      }
    },
    "ai_legal_page": {
      "title": "Legal DZ AI",
      "description": "مساعد قانوني سيادي مدعوم بالذكاء الاصطناعي",
      "system": "DZ-LEGAL-CORE",
      "infrastructure": "البنية التحتية",
      "active": "نشط",
      "mission_vision": "المهمة والرؤية",
      "mission_headline_1": "تحليل",
      "mission_headline_2": "قانوني",
      "mission_headline_3": "سيادي",
      "mission_text": "تم تصميم Legal DZ AI للاستجابة لخصوصيات القانون التجاري المحلي، مما يضمن الامتثال الكامل.",
      "garanties": "ضمانات النظام",
      "garanties_list": {
        "g1": "بيانات مستضافة محلياً",
        "g2": "الامتثال لـ CNPD",
        "g3": "تحديثات يومية"
      },
      "button": "الدخول إلى المنصة",
      "redirection": "إعادة التوجيه إلى DZ-LEGAL-AI.COM",
      "capabilities": {
        "c1": {
          "title": "تحليل فوري",
          "status": "نشط",
          "desc": "معالجة فورية للمستندات القانونية المعقدة."
        },
        "c2": {
          "title": "صياغة مساعدة",
          "status": "تشغيلي",
          "desc": "توليد العقود والصكوك."
        },
        "c3": {
          "title": "رقابة تنظيمية",
          "status": "مزامنة",
          "desc": "متابعة فورية للجريدة الرسمية الجزائرية."
        },
        "c4": {
          "title": "بحث ذكي",
          "status": "متصل",
          "desc": "الوصول إلى قاعدة بيانات الاجتهادات القضائية."
        }
      },
      "metrics_title": "أداء النظام",
      "version": "الإصدار V2.4",
      "metrics": {
        "m1": {
          "label": "الدقة",
          "value": "99.8%",
          "sub": "معدل النجاح"
        },
        "m2": {
          "label": "التأخير",
          "value": "120ms",
          "sub": "وقت الاستجابة"
        },
        "m3": {
          "label": "الرموز",
          "value": "1.2M",
          "sub": "/ ثانية"
        }
      },
      "integration_title": "تكامل عميق",
      "integration_depth": "عمق التحليل",
      "integration_sync": "مزامنة كاملة",
      "integration_text": "محرك الذكاء الاصطناعي مرتبط مباشرة بقاعدة بيانات شركتك لتحقيق أقصى قدر من الملاءمة السياقية.",
      "next_step_title": "الخطوة التالية",
      "next_step_desc": "التكامل المخطط له لوحدات التقاضي في الربع الثالث."
    }
  },
  "brand_val": {
    "report_title": "تقرير تدقيق التسمية",
    "official_document": "وثيقة محاكاة رسمية",
    "government_header": "الجمهورية الجزائرية الديمقراطية الشعبية",
    "ministry_header": "وزارة التجارة وترقية الصادرات",
    "cnrc_header": "المركز الوطني للسجل التجاري",
    "id": "معرف المحاكاة",
    "date": "تاريخ التوليد",
    "executive_summary": "ملخص تنفيذي",
    "status": "الوضع القانوني",
    "explanation": "تفسير الخبراء",
    "details": "تفاصيل تقنية",
    "similarity_analysis": "تحليل التشابه",
    "registry_results": "نتائج السجل",
    "name_col": "الاسم",
    "sector_col": "القطاع",
    "desc_col": "الوصف",
    "score_col": "الدرجة",
    "risk_col": "المخاطر",
    "export_pdf": "تصدير PDF",
    "export_excel": "تصدير Excel",
    "new_search": "بحث جديد",
    "brand_name": "اسم العلامة التجارية",
    "sector": "القطاع الاقتصادي",
    "decision": "القرار الاستراتيجي",
    "recommendations": "التوصيات",
    "risk_none": "لا يوجد",
    "risk_low": "منخفض",
    "risk_medium": "متوسط",
    "risk_high": "عالي",
    "risk_critical": "حرج"
  },
  "name_check": {
    "title": "التحقق من التسمية التجارية",
    "subtitle": "تدقيق قانوني فوري ومصادقة استراتيجية",
    "connected_to": "متصل بـ",
    "central_registry": "السجل المركزي",
    "brand_arbitrage": "التحكيم في العلامة التجارية",
    "description": "يحلل محرك الاستخبارات القانونية علامتك التجارية مقابل قواعد البيانات المؤسساتية ونماذج التشابه الصوتي.",
    "multi_layer_audit": "تدقيق متعدد الطبقات",
    "check_1": "التحقق من الأسبقية في المركز الوطني للسجل التجاري",
    "check_2": "التشابه الصوتي (محرك المطابقة)",
    "check_3": "تحليل المخاطر القطاعية",
    "check_4": "مدى توفر النطاقات (.dz, .com)",
    "step1_label": "1. اسم العلامة التجارية",
    "name_placeholder": "مثال: دي زاد للحلول التقنية",
    "step2_label": "2. قطاع النشاط",
    "step3_label": "3. معلومات إضافية",
    "details_placeholder": "حدد الطبيعة الدقيقة للمنتجات أو الخدمات...",
    "analyzing": "جاري التحليل...",
    "analyze_button": "تحليل العلامة التجارية",
    "database_info": "قاعدة بيانات المركز الوطني للسجل التجاري لعام 2026",
    "compliance_guarantee": "مطابقة قانونية مضمونة",
    "analyzing_title": "إنشاء تقرير التدقيق",
    "analyzing_subtitle": "جاري تحليل سجلات المركز الوطني للسجل التجاري والمعهد الوطني للملكية الصناعية...",
    "sectors": {
      "tech": "التكنولوجيا والأنظمة الرقمية",
      "finance": "المالية والتكنولوجيا المالية",
      "industry": "الصناعة والتصنيع",
      "construction": "البناء والأشغال العمومية والبنية التحتية",
      "services": "الخدمات المهنية",
      "health": "الصحة والصيدلة",
      "trade": "التجارة والتوزيع",
      "agro": "الصناعات الغذائية",
      "telecom": "الاتصالات",
      "other": "قطاعات أخرى"
    },
    "errors": {
      "reserved": "هذا الاسم محجوز بالفعل في جلستك الحالية."
    },
    "engine": {
      "status": {
        "unavailable": "غير متاح",
        "risky": "في خطر",
        "available": "متاح"
      },
      "explanation": {
        "unavailable": "الاسم مسجل بالفعل أو مشابه جداً لكيان موجود.",
        "risky": "اسم مشابه جزئياً. خطر حدوث التباس أو رفض من قبل المركز الوطني للسجل التجاري.",
        "available": "الاسم مطابق ومتاح للاستخدام."
      }
    }
  },
  "name_result": {
    "title": "تقرير: {{name}}",
    "audit_ref": "تدقيق قانوني رسمي • مرجع: {{id}}",
    "archived": "مؤرشف",
    "badge": "تدقيق التسمية",
    "archived_btn": "في الخزنة",
    "archive_btn": "أرشفة",
    "share_btn": "مشاركة",
    "availability_label": "التوفر",
    "status": {
      "valid": "مُصادق عليه",
      "risky": "في خطر",
      "critical": "حرج"
    },
    "main_title_available": "التسمية جاهزة للتسجيل.",
    "main_title_risky": "تم اكتشاف خطر الأسبقية في هذا القطاع.",
    "ministry_stamp_1": "وزارة",
    "ministry_stamp_2": "الصناعة",
    "approved": "مُعتمد",
    "confidence_score": "درجة موثوقية التدقيق",
    "risk_level": "مستوى الخطر",
    "ip_protection": "حماية الملكية الفكرية",
    "ip_protection_status": "مثالي",
    "comparative_analysis": "تحليل مقارن",
    "registry_label": "السجلات الوطنية الجزائرية (المركز الوطني للسجل التجاري)",
    "conflict_phonetic": "تم اكتشاف تعارض صوتي وقطاعي",
    "similarity": "درجة التشابه",
    "no_conflict_title": "لم يتم اكتشاف أي تعارض كبير",
    "no_conflict_desc": "الاسم خالٍ من الأسبقيات الحرجة في قطاع {{sector}}.",
    "system_decision": "قرار النظام",
    "legal_arbitrage": "تحكيم بالذكاء القانوني",
    "recommended_action": "الإجراء الموصى به:",
    "action_accept": "يمكنك المضي قدماً في حجز الاسم وتأسيس الملف.",
    "action_modify": "ننصح بإضافة وصف مميز لتجنب أي رفض من المركز الوطني للسجل التجاري.",
    "action_reject": "هذا الاسم قريب جداً من علامة تجارية مشهورة. الرفض شبه مؤكد.",
    "reserve_btn": "حجز التسمية",
    "launch_creation_btn": "بدء التأسيس",
    "modify_project_btn": "تعديل المشروع",
    "digital_assets": "الأصول الرقمية المتاحة",
    "domain_available": "متاح",
    "domain_taken": "محجوز",
    "validity_title": "صلاحية التدقيق",
    "validity_desc": "72 ساعة (بيانات المركز الوطني للسجل التجاري بالوقت الفعلي)",
    "authenticity_title": "التحقق من الموثوقية",
    "authenticity_desc": "قم بالمسح للتحقق من أصالة الشهادة على بوابة GSD.",
    "modal_title": "تم حجز الاسم بنجاح",
    "modal_desc": "تم تسجيل اختيارك في جلستك الحالية. يمكنك الآن بدء التأسيس الإداري لشركتك.",
    "modal_create_btn": "تأسيس شركتي الآن",
    "modal_close_btn": "إغلاق",
    "modal_validity": "الحجز صالح لمدة 24 ساعة",
    "modal_approved": "قرار معتمد",
    "footer_advisory": "تنبيه: هذا التقرير هو أداة مؤسساتية لدعم اتخاذ القرار. ولا يحل محل رأي مستشار قانوني معتمد.",
    "metrics": {
      "memorability": "سهولة التذكر",
      "protection": "الحماية القانونية",
      "availability": "التوفر",
      "memorability_desc": "يُقيّم مدى سهولة تذكر العملاء لاسم علامتك التجارية.",
      "protection_desc": "يحسب القوة القانونية للعلامة التجارية في مواجهة المنافسين.",
      "availability_desc": "يتحقق من التوفر في الوقت الفعلي في السجلات الرسمية."
    }
  },
  "export": {
    "pdf_header1": "الجمهورية الجزائرية الديمقراطية الشعبية",
    "pdf_header2": "وزارة الصناعة والتجارة - شراكتي GSD",
    "pdf_title": "شهادة تدقيق التسمية",
    "pdf_ref": "المرجع",
    "pdf_details": "تفاصيل المشروع",
    "pdf_name": "التسمية",
    "pdf_sector": "قطاع النشاط",
    "pdf_date": "تاريخ التدقيق",
    "pdf_decision": "القرار",
    "pdf_favorable": "إيجابي",
    "pdf_unfavorable": "سلبي",
    "pdf_modification": "توصية بالتعديل",
    "pdf_analysis_title": "تحليل الأسبقية (المركز الوطني للسجل التجاري / المعهد الوطني للملكية الصناعية)",
    "pdf_table_name": "التسمية المتعارضة",
    "pdf_table_sector": "القطاع",
    "pdf_table_similarity": "التشابه",
    "pdf_table_no_conflict": "لم يتم اكتشاف أي تعارض كبير",
    "pdf_footer1": "تم إنشاء هذا المستند إلكترونياً وله قيمة إعلامية لتأسيس ملف المركز الوطني للسجل التجاري.",
    "pdf_footer2": "يجب أن يحتفظ أي استنساخ بالعلامات المائية الأصلية.",
    "toast_pdf_success": "تم إنشاء التقرير المؤسساتي بصيغة PDF بنجاح",
    "toast_excel_success": "تم تصدير التدقيق المنظم بصيغة Excel",
    "toast_share_success": "تم نسخ رابط التدقيق إلى الحافظة",
    "toast_share_desc": "يمكنك الآن مشاركته بأمان تام.",
    "toast_archive_loading": "أرشفة آمنة في الخزنة المؤسساتية...",
    "toast_archive_success": "تمت أرشفة التقرير بنجاح في مساحتك الآمنة",
    "toast_archive_error": "حدث خطأ أثناء الأرشفة",
    "excel_summary_sheet": "ملخص التدقيق",
    "excel_conflicts_sheet": "التفاصيل المتعارضة",
    "excel_gov_sheet": "الحوكمة والنصائح",
    "excel_gov_title": "نصائح الحوكمة والامتثال",
    "excel_gov_tip1_title": "1. حماية العلامات التجارية",
    "excel_gov_tip1_desc": "يوصى بشدة بتسجيل علامتك التجارية لدى المعهد الوطني للملكية الصناعية (INAPI) فور الحصول على السجل التجاري.",
    "excel_gov_tip2_title": "2. نطاق .DZ",
    "excel_gov_tip2_desc": "يجب إعطاء الأولوية لتسجيل اسم النطاق بتنسيق dz. لترسيخ هويتك الرقمية الوطنية.",
    "excel_gov_tip3_title": "3. العقود الاجتماعية",
    "excel_gov_tip3_desc": "تأكد من أن التسمية متطابقة في جميع مستنداتك وعقودك (القوانين الأساسية، المحاضر، الفواتير).",
    "excel_audit_id": "معرف التدقيق",
    "excel_system_label": "النظام",
    "excel_system_val": "شراكتي GSD الإصدار 4.0 - وزارة الصناعة",
    "excel_explication": "توضيح"
  },
  "statutes_generator": {
    "title": "مولد القوانين الأساسية",
    "subtitle": "قم بإنشاء قوانينك الأساسية المخصصة والمتوافقة مع القانون التجاري الجزائري",
    "actions": {
      "reset": "إعادة تعيين",
      "generate": "توليد القوانين الأساسية",
      "preview": "معاينة",
      "download": "تحميل PDF"
    },
    "sections": {
      "company_info": "معلومات الشركة",
      "legal_form": "الشكل القانوني",
      "capital": "رأس المال",
      "partners": "الشركاء والمساهمون",
      "governance": "الحوكمة والإدارة"
    },
    "fields": {
      "name": "اسم الشركة",
      "name_placeholder": "أدخل اسم الشركة",
      "activity": "النشاط (الغرض)",
      "activity_placeholder": "صف النشاط الرئيسي",
      "duration": "المدة (سنوات)",
      "head_office": "عنوان المقر الرئيسي",
      "head_office_placeholder": "العنوان الكامل في الجزائر",
      "form_label": "اختر الشكل القانوني",
      "capital_amount": "إجمالي رأس المال (د.ج)",
      "share_value": "القيمة الاسمية للسهم",
      "total_shares": "إجمالي عدد الأسهم"
    },
    "forms": {
      "sarl": "ش.ذ.م.م (شركة ذات مسؤولية محدودة)",
      "eurl": "ش.ذ.ش.و (شركة ذات الشخص الوحيد)",
      "spa": "ش.م (شركة مساهمة)",
      "snc": "ش.ت (شركة تضامن)"
    },
    "validation": {
      "incomplete": "يرجى إكمال جميع الحقول المطلوبة",
      "invalid_capital": "يجب أن يكون رأس المال 100,000 د.ج على الأقل لشركة ذات مسؤولية محدودة",
      "no_partners": "مطلوب شريك واحد على الأقل"
    }
  },
  "integrations_page": {
    "title": "الشركاء المتكاملون",
    "description": "المنصات المتصلة ببيئتك الريادية. ادخل إلى الخدمات الأساسية بكل أمان.",
    "partners": {
      "etaxes": {
        "name": "الضرائب الإلكترونية",
        "desc": "منصة إدارة الضرائب لتقديم التصاريح ومتابعة الالتزامات الضريبية."
      },
      "guichet": {
        "name": "الشباك الموحد",
        "desc": "نظام مركزي لإنشاء وإدارة الشركات إدارياً."
      },
      "moustachir": {
        "name": "مستشير إدارتي",
        "desc": "منصة المرافقة الإدارية والاستشارات للمقاولين."
      },
      "cnrc": {
        "name": "السجل التجاري (سجلكوم)",
        "desc": "السجل التجاري للتحقق وتسجيل الشركات."
      },
      "sarfipay": {
        "name": "سرفي باي",
        "desc": "حل دفع إلكتروني متكامل للمعاملات والخدمات المالية."
      }
    },
    "status": {
      "operational": "عملي",
      "connected": "متصل",
      "certified": "معتمد",
      "active": "نشط",
      "coming_soon": "قيد التكامل"
    },
    "access_btn": "دخول",
    "redirecting": "جاري التحويل إلى {{name}}...",
    "external_link_notice": "سيتم توجيهكم إلى منصة خارجية آمنة.",
    "ecosystem": {
      "title": "اتصال كامل",
      "desc": "تجمع شريكتي أفضل الخدمات الرقمية لتبسيط مسار نموك."
    },
    "popup": {
      "title": "قريباً",
      "desc": "هذا التكامل قيد التطوير حالياً من قبل فرقنا التقنية.",
      "btn": "مفهوم"
    },
    "error": {
      "title": "خطأ في التحميل",
      "description": "تعذّر تحميل بيانات التكاملات. يرجى المحاولة مجدداً.",
      "reset": "إعادة المحاولة"
    },
    "options": {
      "yes": "نعم",
      "no": "لا"
    }
  },
  "genvest": {
    "portfolio": {
      "title": "محطة المحفظة",
      "subtitle": "إدارة مؤسسية للأصول وتحليل الأداء في الوقت الفعلي.",
      "real_mode": "الوضع الحقيقي",
      "simulation_mode": "المحاكاة",
      "sync_complete": "اكتملت المزامنة",
      "sync_success": "تمت مزامنة بيانات السوق بنجاح",
      "new_position": "مركز جديد",
      "tabs": {
        "overview": "نظرة عامة",
        "analysis": "تحليلات متقدمة",
        "actions": "التنفيذ والتدفقات",
        "ceo_view": "عرض المدير التنفيذي",
        "analyst_view": "عرض المحلل",
        "execution_view": "عرض التنفيذ"
      },
      "executive_dashboard": "لوحة القيادة التنفيذية",
      "historical_performance": "الأداء التاريخي",
      "portfolio_label": "المحفظة",
      "benchmark_label": "المعيار الجزائري",
      "strategic_allocation": "التخصيص الاستراتيجي",
      "risk_analysis": "تحليل المخاطر الخوارزمي",
      "diversification_score": "درجة التنويع",
      "metrics": {
        "volatility": "التقلب (Ex-post)",
        "volatility_desc": "المخاطر التاريخية السنوية",
        "sharpe": "نسبة شارب",
        "sharpe_desc": "الأداء / المخاطر",
        "var": "القيمة المعرضة للمخاطر (95%)",
        "var_desc": "أقصى خسارة (يوم واحد)",
        "cvar": "القيمة المعرضة للمخاطر المشروطة (95%)",
        "cvar_desc": "العجز المتوقع",
        "return": "العائد المتوقع",
        "return_desc": "توقعات 12 شهراً",
        "drawdown": "أقصى تراجع",
        "drawdown_desc": "أقصى انخفاض تاريخي"
      },
      "position_management": "إدارة المراكز",
      "assets_under_management": "{{count}} أصول تحت الإدارة",
      "execution_center": "مركز التنفيذ",
      "rebalance_audit": "إعادة التوازن والتدقيق",
      "execution_desc": "تحديث المراكز وفقاً للاستراتيجية المستهدفة",
      "ai_audit": "تدقيق الذكاء الاصطناعي",
      "rebalance": "إعادة التوازن",
      "deposit_funds": "إيداع أموال",
      "liquidate_all": "تصفية الكل",
      "flow_history": "سجل التدفقات",
      "diversification_comment": "تُظهر محفظتك تنويعاً قوياً في القطاعات الاستراتيجية الجزائرية.",
      "sync_in_progress": "جاري مزامنة بيانات السوق...",
      "simulation": "محاكاة",
      "allocation": {
        "by_type": "التوزيع حسب النوع",
        "by_type_desc": "أوزان فئات الأصول في المحفظة الإجمالية",
        "by_sector": "التعرض القطاعي",
        "by_sector_desc": "تركيز رأس المال حسب قطاع النشاط"
      },
      "insights": {
        "ai_title": "رؤى Genvest AI",
        "default_category": "تحليل المحفظة",
        "estimated_impact": "التأثير المتوقع",
        "rebalance_suggested": "إعادة التوازن المقترحة",
        "rebalance_desc": "انحرفت محفظتك عن مسارها المستهدف. يقترح الذكاء الاصطناعي {{count}} تعديلات لتحسين توازن العائد/المخاطر.",
        "apply_rebalance": "تطبيق إعادة التوازن"
      },
      "stats": {
        "total_value": "القيمة الإجمالية",
        "simulated": "محاكاة",
        "performance_ytd": "الأداء منذ بداية العام",
        "assets_held": "الأصول المملوكة",
        "cash_excluded": "باستثناء السيولة (النقد)",
        "asset_alloc": "توزيع الأصول",
        "risk_score": "درجة المخاطر",
        "risk_level": "المستوى {{level}}",
        "diversification": "التنويع",
        "hhi_score": "درجة تحسين HHI",
        "portfolio_health": "صحة المحفظة",
        "health_excellent": "ممتازة",
        "health_optimal": "مثالية",
        "health_low": "منخفضة",
        "sharpe_ratio": "نسبة شارب",
        "optimal": "مثالي",
        "max_drawdown": "أقصى تراجع",
        "available_cash": "السيولة المتاحة",
        "deposit": "إيداع",
        "levels": {
          "LOW": "منخفض",
          "MODERATE": "متوسط",
          "HIGH": "عالي",
          "EXTREME": "مرتفع جداً"
        }
      },
      "inventory": {
        "title": "مخزون الأصول",
        "subtitle": "تفاصيل كاملة لمراكزك الحالية",
        "search_placeholder": "البحث عن أصل...",
        "add_button": "إضافة",
        "table": {
          "asset": "الأصل / الرمز",
          "type": "النوع / القطاع",
          "qty": "الكمية",
          "price": "متوسط سعر الشراء / الحالي",
          "total": "القيمة الإجمالية",
          "performance": "الأداء",
          "signal": "إشارة الذكاء الاصطناعي",
          "actions": "الإجراءات",
          "pamp_label": "م.س.ش: ",
          "hold": "احتفاظ",
          "buy": "تجميع",
          "sell": "تخفيف",
          "analyzing": "جاري التحليل...",
          "edit_tooltip": "تعديل الإعدادات",
          "remove_tooltip": "تصفية المركز"
        },
        "empty": {
          "title": "لا توجد أصول في السجل المؤسسي.",
          "action": "استيراد أول أصل"
        }
      },
      "performance": {
        "title": "الأداء النسبي",
        "simulated_projection": "توقعات محاكاة",
        "vs_benchmark": "مقابل المعيار",
        "subtitle_simulated": "نمذجة تنبؤية بناءً على ملف المستثمر",
        "subtitle_real": "مقارنة ديناميكية للقيمة الصافية للأصول (NAV)",
        "simulated_data": "بيانات محاكاة",
        "portfolio": "المحفظة",
        "benchmark": "المعيار (مؤشر د.ج)",
        "alpha_label": "الأداء المتفوق",
        "legend_portfolio": "ألفا المحفظة",
        "legend_benchmark": "مؤشر السوق د.ج"
      },
      "modals": {
        "asset": {
          "title_add": "استثمار جديد",
          "title_edit": "إدارة الأصل",
          "subtitle": "تكوين المعايير المؤسسية للأصل",
          "name_label": "اسم الأصل",
          "name_placeholder": "مثال: الجزائر للنمو",
          "symbol_label": "الرمز",
          "symbol_placeholder": "مثال: DZG-2026",
          "type_label": "نوع الأصل",
          "sector_label": "القطاع الاستراتيجي",
          "financial_data": "بيانات المعاملات",
          "qty_label": "الكمية",
          "avg_price_label": "متوسط سعر الشراء",
          "current_price_label": "السعر الحالي",
          "volatility_label": "التقلب المتوقع",
          "inflation_label": "حماية التضخم",
          "submit_add": "تأكيد الاستثمار",
          "submit_edit": "حفظ التعديلات"
        }
      },
      "asset_types": {
        "EQUITY": "أسهم",
        "EQUITY_desc": "أوراق مالية لرأس مال الشركات",
        "BOND": "سندات",
        "BOND_desc": "سندات الدين (حكومية أو مؤسسية)",
        "REAL_ASSET": "أصول عقارية",
        "REAL_ASSET_desc": "العقارات، الزراعة، الصناعة",
        "STARTUP_SHARE": "شركات ناشئة",
        "STARTUP_SHARE_desc": "رأس المال الاستثماري والمساهمات المباشرة"
      },
      "sectors": {
        "Technology": "التكنولوجيا",
        "Finance": "المالية",
        "Energy": "الطاقة",
        "Healthcare": "الرعاية الصحية",
        "Consumer": "الاستهلاك",
        "Real Estate": "العقارات",
        "Government": "حكومي",
        "Agriculture": "الزراعة",
        "Industrie": "الصناعة",
        "Communication": "اتصالات",
        "Etat": "الدولة",
        "Immobilier": "العقارات",
        "Technologie": "التكنولوجيا",
        "Gouvernement": "حكومي",
        "Other": "أخرى"
      },
      "stress_testing": {
        "title": "محاكاة الأزمات (اختبار الإجهاد)",
        "subtitle": "تحليل مرونة المحفظة في مواجهة الصدمات الاقتصادية الكبرى.",
        "scenarios": {
          "RATES_HIKE": {
            "title": "رفع أسعار الفائدة (+200 نقطة أساس)",
            "type": "سيناريو ماكرو"
          },
          "INFLATION_SPIKE": {
            "title": "صدمة تضخمية (15%)",
            "type": "سيناريو ماكرو"
          },
          "MARKET_CRASH": {
            "title": "انهيار السوق (-35%)",
            "type": "سيناريو ماكرو"
          },
          "descriptions": {
            "RATES_HIKE": "رفع الفائدة بمقدار +200 نقطة أساس: تصحيح حاد في الأصول طويلة الأجل (السندات، العقارات) وضغط على تقييمات شركات التكنولوجيا.",
            "INFLATION_SPIKE": "صدمة تضخمية (15%): تآكل كبير في السيولة والسندات الاسمية. حماية جزئية عبر العقارات والأصول الحقيقية.",
            "MARKET_CRASH": "انهيار السوق النظامي (-35%): انهيار الأصول ذات المخاطر العالية. فقط السندات السيادية توفر حماية عبر الارتباط العكسي.",
            "empty": "لا يوجد تأثير متوقع (المحفظة فارغة)"
          }
        },
        "results": {
          "impact_estimated": "التأثير المتوقع",
          "severity": "الشدة",
          "critical": "حرجة",
          "moderate": "متوسطة",
          "hedging_btn": "محاكاة التحوط"
        },
        "empty_state": "اختر سيناريو لبدء محاكاة الأزمة"
      },
      "audit": {
        "title": "تدقيق الامتثال",
        "subtitle": "تقرير مؤسسي Genvest AI",
        "demo_warning": "تنبيه: تقرير مبني على بيانات محاكاة (وضع تجريبي)",
        "global_status": "الحالة العامة",
        "integrity_status": "سليم",
        "last_check": "آخر تحقق",
        "analysis_title": "تحليل نقاط التحقق",
        "download_btn": "تحميل PDF معتمد",
        "validate_btn": "تصديق التقرير",
        "footer_certification": "شهادة متوافقة مع معايير سلطة الضبط (متوافق مع COSO)",
        "checks": {
          "allocation": {
            "title": "حدود التخصيص التنظيمية",
            "desc": "لا تتجاوز أي فئة أصول العتبات الاحترازية التي تحددها الاستراتيجية."
          },
          "esg": {
            "title": "الامتثال البيئي والاجتماعي والحوكمة",
            "desc": "متوسط درجة المحفظة: 84/100. انسجام قوي مع معايير التمويل المستدام."
          },
          "concentration": {
            "title": "تنبيه التركيز القطاعي",
            "desc": "الحد الأقصى للتعرض القطاعي هو {{percentage}}%."
          },
          "liquidity": {
            "title": "نسبة تغطية السيولة",
            "desc": "تمثل سيولتكم {{percentage}}% من الإجمالي."
          }
        },
        "status": {
          "compliant": "مطابق",
          "optimal": "مثالي",
          "warning": "تحذير",
          "critical": "حرج"
        }
      },
      "transactions": {
        "title": "سجل المعاملات",
        "subtitle": "أرشيف كامل لتحركات رأس المال الخاصة بك",
        "empty": "لم يتم تسجيل أي معاملات.",
        "table": {
          "date": "التاريخ",
          "action": "الإجراء",
          "asset": "الأصل / الوصف",
          "qty": "الكمية",
          "price": "سعر الوحدة",
          "total": "الإجمالي",
          "status": "الحالة"
        },
        "status": {
          "completed": "مكتمل",
          "pending": "قيد الانتظار",
          "cancelled": "ملغى"
        },
        "types": {
          "buy": "شراء",
          "sell": "بيع",
          "dividend": "توزيعات أرباح",
          "fee": "رسوم",
          "deposit": "إيداع",
          "withdraw": "سحب"
        }
      }
    }
  },
  "finance": {
    "etaxes": {
      "portal_title": "بوابة الضرائب الإلكترونية",
      "unified_interface": "واجهة موحدة",
      "partnership_prefix": "التكامل المباشر الرسمي لـ DGI عبر ",
      "direct_link": "اتصال مباشر",
      "nodes_dgi": "عقدة DGI نشطة",
      "auth_sig": "التوقيع الرقمي: ",
      "proto_ready": "النظام جاهز",
      "syncing": "مزامنة...",
      "unified_space": "المساحة الضريبية الموحدة",
      "secure_gateway": "البوابة المؤسسية لإدارة الالتزامات الضريبية الجزائرية.",
      "dgi_apps": "صرح بـ G50 و IBS و TAP بنقرة واحدة.",
      "open_portal": "الدخول إلى بوابة DGI",
      "sync_progress": "تحديث البيانات",
      "verify_obligations": "التحقق من الالتزامات",
      "gateway": "بوابة DGI",
      "master_server": "عقدة سيادية",
      "compliance_deadlines": "تقويم الامتثال الضريبي",
      "fiscal_year": "السنة المالية",
      "action_required": "إجراء مطلوب",
      "file_closed": "ممتثل",
      "pending": "قيد الانتظار",
      "decl_g50": "تصريح G50",
      "acompte_prov": "دفعة مؤقتة IBS",
      "opening_doc": "جاري فتح وثائق DGI...",
      "dgi_doc": "دليل DGI الرسمي",
      "connecting_expert": "جاري الاتصال بمستشار ضريبي...",
      "direct_support": "الدعم المؤسسي"
    },
    "advisor": {
      "engine": "محرك تقديم المشورة",
      "fin_decision": " مركز القرار المالي",
      "premium_hub": "نظام تقديم المشورة السيادي نشط",
      "sync_real": "مزامنة مع البيانات الحقيقية",
      "sim_inputs": "معلمات مدخلات المحاكاة",
      "op_params": "المعلمات التشغيلية",
      "monthly_rev": "الإيرادات الشهرية (د.ج)",
      "avail_liquidity": "النقد المتاح / السيولة (د.ج)",
      "fixed_costs": "التكاليف الثابتة الشهرية (د.ج)",
      "var_costs": "التكاليف المتغيرة الشهرية (د.ج)",
      "debt_service": "خدمة الدين الشهرية (د.ج)",
      "tax_prov": "المخصصات الضريبية (د.ج)",
      "expected_inflows": "التدفقات النقدية الواردة المتوقعة (30 يوم)",
      "upcoming_payments": "المدفوعات القادمة (30 يوم)",
      "inv_context": "سياق الاستثمار",
      "capex": "تكلفة المشروع / النفقات الرأسمالية (د.ج)",
      "expected_roi": "العائد المتوقع على الاستثمار (%)",
      "risk_profile": "متطلبات ملف تعريف المخاطر",
      "analyze_data": "تحليل المعلمات المالية",
      "launch_ai": "إطلاق محاكاة الذكاء الاصطناعي",
      "est_time": "الوقت المقدر للتنفيذ: ",
      "results_intelligence": "نتائج المحاكاة والذكاء المالي",
      "sim_pending": "المحاكاة قيد الانتظار",
      "config_params": "قم بتهيئة معلمات التشغيل والاستثمار الخاصة بك أعلاه ثم قم بتشغيل محرك الذكاء الاصطناعي.",
      "ai_verdict": "قرار محاكاة الذكاء الاصطناعي",
      "optimal": "مثالي",
      "prudence": "حذر",
      "critical": "حرِج",
      "health_score": "درجة الصحة المالية",
      "proj_roi": "العائد المتوقع على استثمار المشروع",
      "cash_pos": "الوضع النقدي بعد الاستثمار",
      "save": "حفظ القرار",
      "key_indicators": "مؤشرات التشغيل الرئيسية",
      "revenue": "الإيرادات الشهرية",
      "monthly": "شهري",
      "rev_flow": "متوسط الإيرادات التشغيلية الشهرية",
      "margin": "الهامش",
      "net_op_perf": "صافي الهامش التشغيلي قبل الديون والضرائب",
      "unlimited": "غير محدود",
      "proj_fin_autonomy": "الاستقلالية المالية المتوقعة بالأشهر",
      "dscr_ratio": "نسبة DSCR",
      "debt_cov_cap": "قدرة تغطية خدمة الدين",
      "proj_balance": "الرصيد النقدي المتوقع (30 يوم)",
      "current_treasury": "الخزينة الحالية",
      "net_flow_30": "التدفقات النقدية المتوقعة (30 يوم)",
      "debt_serv": "سداد خدمة الدين",
      "net_position": "الوضع الصافي المتوقع",
      "rational_analysis": "التحليل العقلاني للذكاء الاصطناعي",
      "internal_health": "تشخيص الصحة الداخلية",
      "growth_potential": "منطق الاستثمار والنمو",
      "sec_mitigation": "الأمن وتخفيف المخاطر",
      "strat_directives": "التوجيهات الاستراتيجية",
      "impact": " تأثير",
      "action_lever": "تنفيذ رافعة العمل",
      "risk_control": "مراقبة المخاطر والتنبيهات",
      "secure_perimeter": "محيط آمن",
      "no_crit_alert": "لم يتم الكشف عن مخاطر حرجة في المحاكاة الحالية.",
      "decision_archive": "أرشيف القرارات (الجلسة)",
      "empty_log": "لم يتم تسجيل أي قرارات في الجلسة الحالية."
    },
    "reports": {
      "title": "التقارير المالية",
      "desc": "توليد وتحليل الميزانيات العمومية وبيانات الدخل والملفات الضريبية.",
      "back": "العودة إلى لوحة التحكم المالية",
      "detailed_mode": "الوضع التفصيلي",
      "activated": "نشط",
      "synthetic": "مركب",
      "processing": "جاري المعالجة...",
      "start_analysis": "بدء تحليل التقرير",
      "hide_options": "إخفاء الخيارات المتقدمة",
      "adv_options": "عرض الخيارات المتقدمة",
      "dgi_audit": "التحقق من الامتثال قبل تدقيق DGI",
      "include_drafts": "تضمين المسودات والقيود المؤقتة"
    },
    "alertes": {
      "major": "تنبيه رئيسي",
      "optimization": "تنبيه تحسين",
      "tax": "الامتثال الضريبي",
      "cash_flow": "التدفق النقدي والسيولة",
      "cost": "التحكم في التكاليف",
      "performance": "الأداء التشغيلي",
      "score": "درجة المخاطر العامة",
      "unified_risk_index": "مؤشر المخاطر والتعرض الموحد",
      "severity_alert": "تنبيه خطورة نشط",
      "high_vigilance": "مطلوب يقظة عالية",
      "sys_stability": "استقرار مثالي للنظام",
      "financial_exposure": "التعرض المالي المقدر (د.ج)",
      "live_risk_engine": "محرك تحليل المخاطر المباشر",
      "audit_proto": "بروتوكول التدقيق: ",
      "active": "نشط",
      "last_scan": "آخر فحص: ",
      "selected_alert": "تنبيه محدد",
      "selected_alerts": "تنبيهات محددة",
      "bulk_processing": "وحدة التحكم في الإجراءات الجماعية",
      "deselect_all": "إلغاء تحديد الكل",
      "resolve": "حل المحدد",
      "ignore": "تجاهل المحدد",
      "analyze": "تحليل عميق",
      "access": "الدخول إلى الوحدة المستهدفة",
      "threat_feed": "خلاصة معلومات التهديدات والمخاطر",
      "search_ph": "تصفية التنبيهات النشطة حسب مستوى التهديد، الفئة...",
      "select_all": "تحديد كل التنبيهات",
      "urgent": "مطلوب علاج عاجل",
      "normal_opt": "استشاري تحسين عادي",
      "no_signal": "لا توجد تنبيهات نشطة تطابق التصفية",
      "regulation": "سياق التنظيم",
      "risk_severity": "تصنيف خطورة المخاطر وتأثيرها",
      "systemic_diag": "التشخيص النظامي",
      "risk_drivers": "محركات المخاطر والأسباب الجذرية",
      "board_rec": "توصيات مجلس الإدارة",
      "priority_opt": "تحسين الأولوية",
      "audit_trail": "مسار التدقيق وسجلات التحقق",
      "pending_cfo": "العلاج في انتظار موافقة المدير المالي",
      "no_remediation": "لم يتم اتخاذ أي إجراء علاجي بعد.",
      "synth_grouped": "لوحة العمل التركيبية",
      "dynamic_audit": "التدقيق الديناميكي لـ ",
      "vigilance_points": " نقاط اليقظة",
      "exit_mode": "الخروج من التحديد المتعدد",
      "cum_impact": "الأثر المالي التراكمي (د.ج)",
      "avg_gravity": "متوسط تصنيف الجاذبية",
      "synth_rec": "توصيات استشارية تركيبية",
      "resolve_all": "حل جميع التنبيهات المحددة",
      "context_nav": "فتح وحدة السياق",
      "pending_risk_analysis": "حدد تنبيهاً نشطاً لعرض التفاصيل العميقة.",
      "identify_threat": "تحديد التهديدات وتحسين الامتثال.",
      "balance_solidity": "صلابة الميزانية العمومية",
      "tax_burden": "مؤشر العبء الضريبي",
      "op_leverage": "الرافعة التشغيلية",
      "integrated_sys": "فحص المخاطر متكامل تماماً مع عقد DGI.",
      "expert_help": "هل تحتاج إلى مشورة قانونية من خبير؟"
    },
    "evaluation": {
      "pot_score": "درجة إمكانات السوق",
      "risk_control_lbl": "مستوى المخاطر والتحكم",
      "stars": "STARS",
      "stable": "STABLE",
      "growth": "نمو مرتفع",
      "at_risk": "معرض للخطر",
      "project_eval": "مشروع التقييم ",
      "sys_selection": "محرك دعم القرار",
      "reset": "إعادة ضبط المحاكاة",
      "project_params": "معلمات المشروع التشغيلية",
      "define_context": "حدد الأبعاد الرئيسية لمشروع عملك لتقييم الذكاء الاصطناعي.",
      "eval_name": "اسم التقييم",
      "ex_project": "مثال: إطلاق منصة التكنولوجيا المالية",
      "sector": "قطاع النشاط",
      "maturity_stage": "مرحلة النضج",
      "eval_profile": "ملف التقييم",
      "launch_eval": "إطلاق التقييم",
      "update_analysis": "تحديث التحليل",
      "team": "الفريق وقدرة التنفيذ",
      "market_pot": "إمكانات السوق والطلب",
      "bus_model": "نموذج العمل وجدواه",
      "innovation": "الابتكار والحواجز التكنولوجية",
      "feasibility": "الجدوى المالية والتشغيلية",
      "risk": "محيط المخاطر والامتثال",
      "analysis_verdict": "قرار تقييم الذكاء الاصطناعي",
      "strat_interp": "التفسير الاستراتيجي لمؤشرات مشروعك.",
      "share_committee": "المشاركة مع اللجنة",
      "score_lbl": "الدرجة العامة: ",
      "strengths": "نقاط القوة النظامية الرئيسية",
      "no_crit_strength": "لا توجد قوة حاسمة بارزة. اعمل على التحسين.",
      "risk_zones": "مناطق التعرض والمخاطر الرئيسية",
      "risks_controlled": "يبدو أن جميع المخاطر يتم التحكم فيها بشكل صحيح في هذه المحاكاة.",
      "rec_action_plan": "خطة العمل الموصى بها",
      "no_corr_measures": "لم يتم توليد تدابير تصحيحية بعد.",
      "perf_score": "درجة الأداء التشغيلي",
      "radar_profile": "ملف نضج الرادار",
      "maturity_pillar": "توزيع ركائز النضج",
      "decision_center": "مركز العمل والقرار",
      "compare": "مقارنة عمليات المحاكاة",
      "excel": "تصدير محاكاة إكسل",
      "distribute_com": "التوزيع على لجنة الاستثمار",
      "session_ranking": "تقييمات الجلسة (",
      "report_dist": "التوزيع المؤسسي"
    }
  },
  "kpis_datas": {
    "current_rev_desc": "إجمالي رقم الأعمال المحقق خلال السنة المالية الحالية.",
    "prev_rev_desc": "إجمالي رقم الأعمال المحقق خلال السنة المالية السابقة.",
    "tot_costs": "إجمالي التكاليف التشغيلية",
    "tot_costs_desc": "مجموع التكاليف التشغيلية الثابتة والمتغيرة خلال الفترة.",
    "active": "نشط",
    "curr_assets_desc": "الأصول السائلة أو الموارد التي يمكن تحويلها إلى نقد خلال 12 شهراً.",
    "curr_liab": "الخصوم المتداولة",
    "curr_liab_desc": "الالتزامات المالية قصيرة الأجل المستحقة خلال 12 شهراً.",
    "fin_audit": "تدقيق الأداء المالي",
    "perf_params": "تحليل نسب الميزانية العمومية والهوامش وهيكل رأس المال في الوقت الفعلي.",
    "engine": "محرك المؤشرات",
    "fin_data": "معلمات إدخال النسب المالية",
    "quick_synth": "تركيب النسب في الوقت الفعلي",
    "est_gross_margin": "الهامش الإجمالي المقدر",
    "growth_ratio": "نسبة النمو",
    "run_audit": "تشغيل تدقيق تحليل النسب",
    "sys_ready": "نظام حساب الأداء جاهز."
  },
  "partners_page": {
    "pending": "قيد الانتظار",
    "institutional_network": "شبكة الشركاء المؤسسيين",
    "our_partners": "الشركاء الرسميون",
    "partners_desc": "التواصل والتعاون مع المؤسسات المعتمدة والشبكات المهنية.",
    "admin_mode_active": "وضع المسؤول نشط",
    "admin_sim": "لوحة تحكم محاكاة المسؤول",
    "pending_apps": "طلبات الشراكة قيد الانتظار",
    "validation_req": "التحقق من أوراق الاعتماد والموافقة على طلبات الانضمام إلى الشبكة.",
    "validate": "الموافقة على الطلب",
    "verified": "تم التحقق منه",
    "consult": "استشارة الملف الشخصي",
    "dossier": "ملف",
    "become_partner": "الانضمام إلى النظام البيئي",
    "apply_network": "التقدم بطلب للانضمام إلى الشبكة",
    "apply": "تقديم الطلب",
    "form_name": "الاسم الكامل",
    "function_title": "الوظيفة / المسمى الوظيفي",
    "organization": "المؤسسة / الشركة",
    "form_email": "عنوان البريد الإلكتروني المهني",
    "desc_expertise": "وصف الخبرة ومجال التعاون",
    "proof_doc": "إثبات الكفاءة / الوثيقة المؤسسية",
    "click_upload": "انقر لتحميل مستند PDF أو PNG أو JPG",
    "send_application": "إرسال طلب الشراكة",
    "contact": "معلومات الاتصال",
    "active_partner": "شريك شبكة نشط",
    "join_date": "تاريخ الانضمام",
    "intervention_domains": "مجالات التدخل والخبرة",
    "secure_doc": "الوثائق الآمنة",
    "download": "تحميل الملف",
    "inst_level": "التكامل على المستوى المؤسسي",
    "validated_exp": "شبكات الخبراء المعتمدة",
    "national_cov": "التغطية التشغيلية الوطنية"
  },
  "pricing": {
    "title": "أسعار واضحة وسيادية",
    "subtitle": "لا توجد رسوم مخفية. برمجيات SaaS متميزة، دعم استشاري من الخبراء، وباقات مؤسسية مصممة للبيئة المقاولاتية الجزائرية.",
    "monthly": "دفع شهري",
    "yearly": "دفع سنوي (وفر 15%)",
    "recommended": "موصى به",
    "freemium_title": "نموذج التسعير الخاص بنا",
    "freemium_desc": "تعتمد شاركاتي على نموذج مجاني متطور ممزوج بالخدمات الاستشارية عند الطلب والحلول المؤسسية المخصصة.",
    "philosophy": {
      "saas": {
        "title": "اشتراكات البرمجيات",
        "desc": "الوصول إلى الأدوات الرقمية المتقدمة، والأتمتة القانونية والضريبية ولوحات التحكم الفورية."
      },
      "advisory": {
        "title": "الاستشارات المؤسسية",
        "desc": "خبراء قانونيون وماليون وضريبيون مستعدون لتدقيق ومرافقة هيكل شركتك."
      },
      "partnerships": {
        "title": "شركاء النظام البيئي",
        "desc": "حزم خاصة بالحاضنات ومسرعات الأعمال والمدن التكنولوجية والجامعات."
      }
    },
    "plans": {
      "free": {
        "name": "مجاني",
        "price": "0",
        "period": "د.ج/شهريًا",
        "desc": "مثالي للطلاب، التحقق من الأفكار، والمقاولين في البداية.",
        "button": "ابدأ مجاناً",
        "features": [
          "دخول لوحة التحكم الأساسية",
          "مشروع نشط واحد",
          "دعم مجتمعي أساسي",
          "طلبات ذكاء اصطناعي محدودة",
          "الوصول إلى النواة السيادية للنظام"
        ]
      },
      "starter": {
        "name": "Starter",
        "price": "1,500",
        "price_year": "15,000",
        "period": "د.ج/شهريًا",
        "desc": "للمستقلين، أصحاب المهن الحرة، والمشاريع في مرحلة الانطلاق.",
        "button": "اختيار Starter",
        "features": [
          "لوحة تحكم متقدمة",
          "3 مشاريع نشطة",
          "نماذج الوثائق القياسية",
          "مساعد الذكاء الاصطناعي Lite",
          "الدعم عبر البريد الإلكتروني",
          "مؤشرات مالية أساسية"
        ]
      },
      "pro": {
        "name": "Pro",
        "price": "4,500",
        "price_year": "45,000",
        "period": "د.ج/شهريًا",
        "desc": "مثالي للمؤسسات الناشئة في طور النمو والشركات المتوسطة الرقمية.",
        "button": "اختيار Pro",
        "features": [
          "مشاريع نشطة غير محدودة",
          "محرك الذكاء الاصطناعي المتقدم",
          "باقات الخدمات القانونية والضريبية الكاملة",
          "عمليات التحقق المسبق من الامتثال",
          "دعم ذو أولوية 24/7",
          "الربط البرمجي الكامل (Beta)"
        ]
      },
      "business": {
        "name": "Business",
        "price": "9,000",
        "price_year": "90,000",
        "period": "د.ج/شهريًا",
        "desc": "للمؤسسات القائمة التي تتطلب تحليلات متقدمة ومساحات عمل مشتركة.",
        "button": "اختيار Business",
        "features": [
          "كل ميزات Pro",
          "مساحة عمل متعددة المستخدمين",
          "تقارير مالية وتحليلية متقدمة",
          "لوحة تحكم خاصة بالمستثمرين",
          "تصدير البيانات المحاسبية",
          "أولوية الوصول للربط البرمجي"
        ]
      },
      "enterprise": {
        "name": "Enterprise",
        "price": "مخصص",
        "period": "عند الطلب",
        "desc": "للمجموعات، الحاضنات، الجامعات، والمؤسسات العامة.",
        "button": "اتصل بنا",
        "features": [
          "ربط مباشر مع الشباك الموحد و DGI",
          "مزامنة ضريبية إلكترونية كاملة",
          "خيار استضافة الخوادم المحلية الخاص",
          "مدير حساب مخصص و اتفاقية مستوى الخدمة",
          "تطوير وتخصيص الربط البرمجي الخاص",
          "حصص تدريبية ومرافقة مخصصة"
        ]
      }
    },
    "consulting": {
      "title": "استشارات مؤسسية عند الطلب",
      "subtitle": "احصل على دعم مباشر من رواد خبراء الشركات في الجزائر.",
      "legal": {
        "title": "الاستشارات القانونية",
        "desc": "قانون الشركات، صياغة القوانين الأساسية المخصصة وحوكمة مجالس الإدارة.",
        "price": "15,000 د.ج",
        "duration": "1-3 أيام"
      },
      "finance": {
        "title": "الاستشارات المالية",
        "desc": "هيكلة التدفقات النقدية، النماذج المالية المعقدة، وتخطيط النفقات الرأسمالية.",
        "price": "20,000 د.ج",
        "duration": "2-4 أيام"
      },
      "tax": {
        "title": "الاستشارات الضريبية",
        "desc": "تحسين الضرائب (IBS/TAP)، المساعدة في تصريحات الرسم على القيمة المضافة والتدقيق المسبق.",
        "price": "18,000 د.ج",
        "duration": "1-2 أيام"
      },
      "strategy": {
        "title": "استراتيجية الأعمال",
        "desc": "دخول السوق الجزائرية، توجيهات التوسع والامتثال للتشريعات المحلية.",
        "price": "30,000 د.ج",
        "duration": "أسبوع واحد"
      },
      "request": "طلب استشارة"
    },
    "services": {
      "investment": {
        "title": "خدمات الاستثمار من GENVEST",
        "desc": "تعمل شاركاتي كواجهة استراتيجية لتمويل المشاريع الناشئة، وبناء شبكات المستثمرين الملائكيين، والربط برؤوس الأموال السيادية. نحن نقدم أقصى درجات الأمان القانوني والتدقيق لأوراق عرض مشروعك."
      },
      "government": {
        "title": "الرقمنة والقطاع العام",
        "desc": "نقوم ببناء واجهات ربط برمجية مخصصة للإدارات العمومية والجامعات والوكالات الإقليمية لتسهيل التسجيل في السجل التجاري وتصريحات الضمان الاجتماعي CNAS."
      }
    },
    "faq": {
      "title": "الأسئلة الشائعة",
      "q1": "كيف تعمل الاشتراكات؟",
      "a1": "يمكنك الاختيار بين الفوترة الشهرية أو السنوية. وتستطيع ترقية اشتراكك أو خفضه فوراً من لوحة التحكم الخاصة بك.",
      "q2": "هل تصريحاتي الضريبية متوافقة قانوناً؟",
      "a2": "نعم. يتوافق نظام التصريح الضريبي الإلكتروني لدينا تماماً مع قانون الضرائب الجزائري العام ومتطلبات المديرية العامة للضرائب.",
      "q3": "هل يمكنني إلغاء اشتراكي في أي وقت؟",
      "a3": "بكل تأكيد. يمكنك إلغاء اشتراكك بنهاية دورة الفوترة الحالية دون أي تكاليف إضافية أو عقوبات.",
      "q4": "ما هي طرق الدفع المدعومة؟",
      "a4": "نحن ندعم الدفع عبر البطاقة البنكية CIB، تطبيق BaridiMob، والتحويل البنكي العادي، مع توفير الفواتير آلياً."
    },
    "compare_features": "مقارنة الميزات كاملة",
    "feature": "الميزة",
    "free": "مجاني",
    "starter": "Starter",
    "pro": "Pro",
    "business": "Business",
    "enterprise": "Enterprise",
    "payment": {
      "title": "طرق الدفع المقبولة",
      "cib": "بطاقة CIB",
      "baridi": "بريدي موب",
      "transfer": "تحويل بنكي"
    },
    "cta": {
      "title": "هل أنت مستعد لرقمنة شركتك؟",
      "subtitle": "انضم إلى آلاف المقاولين الجزائريين الذين يستخدمون شاركاتي لإدارة أعمالهم اليومية.",
      "start": "ابدأ الآن مجاناً",
      "demo": "احجز عرضاً تجريبياً",
      "contact": "اتصل بفريقنا"
    }
  }
}
